// src/components/ServerDatabase/ServerKpiStats.jsx
import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';

const formatNumber = (num) => {
  if (num === null || num === undefined) return '';
  if (typeof num === 'string') return num;
  return String(num).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

const ServerKpiStats = ({ totalServers, totalPlayers }) => {
  const { language } = useLanguage();
  const isEn = language === 'en';

  const formattedServers = totalServers ? formatNumber(totalServers) : '4,820+';
  const formattedPlayers = totalPlayers ? formatNumber(totalPlayers) : '128,400+';

  return (
    <section className="sdb-global-stats-section">
      <div className="sdb-stats-strip-grid">
        
        {/* Карточка 1: Серверов в базе */}
        <div className="sdb-stat-kpi-card">
          <svg className="sdb-stat-kpi-icon-bg" viewBox="0 0 24 24" fill="currentColor">
            <rect width="20" height="8" x="2" y="2" rx="2" ry="2" />
            <rect width="20" height="8" x="2" y="14" rx="2" ry="2" />
          </svg>
          <div className="sdb-stat-kpi-card-inner">
            <div className="sdb-stat-kpi-num">{formattedServers}</div>
            <div>
              <div className="sdb-stat-kpi-label">
                {isEn ? 'Servers in Database' : 'Серверов в базе'}
              </div>
              <div className="sdb-stat-kpi-desc">
                {isEn ? 'Indexed and verified in real time' : 'Проиндексировано и проверено в реальном времени'}
              </div>
            </div>
          </div>
        </div>

        {/* Карточка 2: Игроков онлайн */}
        <div className="sdb-stat-kpi-card">
          <svg className="sdb-stat-kpi-icon-bg" viewBox="0 0 24 24" fill="currentColor">
            <circle cx="12" cy="8" r="5" />
            <path d="M20 21a8 8 0 1 0-16 0" />
          </svg>
          <div className="sdb-stat-kpi-card-inner">
            <div className="sdb-stat-kpi-num">{formattedPlayers}</div>
            <div>
              <div className="sdb-stat-kpi-label">
                {isEn ? 'Players Online' : 'Игроков онлайн'}
              </div>
              <div className="sdb-stat-kpi-desc">
                {isEn ? 'Total active players across indexed nodes' : 'Суммарный онлайн на доступных серверах'}
              </div>
            </div>
          </div>
        </div>

        {/* Карточка 3: RCON / Auth Уязвимы */}
        <div className="sdb-stat-kpi-card">
          <svg className="sdb-stat-kpi-icon-bg" viewBox="0 0 24 24" fill="currentColor">
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
            <path d="M7 11V7a5 5 0 0 1 10 0v4" />
          </svg>
          <div className="sdb-stat-kpi-card-inner">
            <div className="sdb-stat-kpi-num">1,412</div>
            <div>
              <div className="sdb-stat-kpi-label">
                {isEn ? 'Compromised' : 'Скомпрометировано'}
              </div>
              <div className="sdb-stat-kpi-desc">
                {isEn ? 'Exposed RCON port or dumped credentials' : 'Открытый RCON порт или слитая база паролей'}
              </div>
            </div>
          </div>
        </div>

        {/* Карточка 4: Средний пинг */}
        <div className="sdb-stat-kpi-card">
          <svg className="sdb-stat-kpi-icon-bg" viewBox="0 0 24 24" fill="currentColor">
            <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
          </svg>
          <div className="sdb-stat-kpi-card-inner">
            <div className="sdb-stat-kpi-num">
              28<span className="sdb-stat-kpi-unit">ms</span>
            </div>
            <div>
              <div className="sdb-stat-kpi-label">
                {isEn ? 'Response Speed' : 'Скорость отклика'}
              </div>
              <div className="sdb-stat-kpi-desc">
                {isEn ? 'Direct tunnel proxy to target nodes' : 'Прямой прокси-туннель до целевых нод'}
              </div>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};

export default ServerKpiStats;
